
namespace TabAurous.HR {

    @Serenity.Decorators.registerClass()
    export class LeaveTypeDialog extends Serenity.EntityDialog<LeaveTypeRow, any> {
        protected getFormKey() { return LeaveTypeForm.formKey; }
        protected getIdProperty() { return LeaveTypeRow.idProperty; }
        protected getLocalTextPrefix() { return LeaveTypeRow.localTextPrefix; }
        protected getNameProperty() { return LeaveTypeRow.nameProperty; }
        protected getService() { return LeaveTypeService.baseUrl; }
        protected getDeletePermission() { return LeaveTypeRow.deletePermission; }
        protected getInsertPermission() { return LeaveTypeRow.insertPermission; }
        protected getUpdatePermission() { return LeaveTypeRow.updatePermission; }

        protected form = new LeaveTypeForm(this.idPrefix);
        constructor() {
            super();
            q.hideCategorylinks(this.element);
            q.HideCategoryLable(this.element);

            q.setTextRightAlign(this.form.MaxLeavesAllowed);
            q.setTextRightAlign(this.form.ApplicableAfter);
            q.setTextRightAlign(this.form.MaxContinuosDays);
            q.setTextRightAlign(this.form.MaxEncashmentDays);

            q.SetCategorySixColumn(this.form.LeaveTypeCode);
            q.SetCategorySixColumn(this.form.IsCarryForward);
            q.SetCategorySixColumn(this.form.AllowEncashment);
            this.form.IsPartiallyPaidLeaves.changeSelect2(e => {
                if (this.form.IsPartiallyPaidLeaves.value)
                    q.showField(this.form.FractionofDailySalaryPerLeave);
                else
                    q.hideField(this.form.FractionofDailySalaryPerLeave);
            });
            this.form.AllowEncashment.changeSelect2(e => {
                if (this.form.AllowEncashment.value) {
                    q.showAndSetRequiredField(this.form.MaxEncashmentDays);
                    q.showAndSetRequiredField(this.form.EncashmentComponentId);
                }
                else {
                    q.hideField(this.form.MaxEncashmentDays);
                    q.hideField(this.form.EncashmentComponentId);
                }
            });
        }
        onDialogOpen() {
            super.onDialogOpen();
            if (this.form.IsPartiallyPaidLeaves.value)
                q.showField(this.form.FractionofDailySalaryPerLeave);
            else
                q.hideField(this.form.FractionofDailySalaryPerLeave);
            if (this.form.AllowEncashment.value) {
                q.showField(this.form.MaxEncashmentDays);
                q.showField(this.form.EncashmentComponentId);
            }
            else {
                q.hideField(this.form.MaxEncashmentDays);
                q.hideField(this.form.EncashmentComponentId);
            }
        }
    }
}